<template>
  <div class="no-products" v-html="NoProducts"></div>
</template>

<script>
import NoProducts from './no-products.svg'
export default {
  data () {
    return {
      NoProducts: NoProducts
    }
  }
}
</script>



// WEBPACK FOOTER //
// uncommon-client/components/svgs/NoProducts.vue